module.exports = __webpack_public_path__ + "02c4dc679860e39156da1b0cdc59ddcb.jpg";